const Sorting = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M12.3999 13.75V1.25M12.3999 1.25L15.3999 4.25M12.3999 1.25L9.3999 4.25" stroke="#141414" />
    <path d="M4 2.25L4 14.75M4 14.75L1 11.75M4 14.75L7 11.75" stroke="#141414" />
  </svg>
)

export { Sorting }
